import { WixPatternsEssentials } from '../model';

export const createUseExperimentsCompat = (
  useExperiments: WixPatternsEssentials['useExperiments'],
) => {
  const fallbackApi = {
    ready: true,
    experiments: {
      enabled: () => false,
    },
  };

  return function useExperimentsCompat() {
    try {
      const experiments = useExperiments();

      if (experiments == null) {
        return fallbackApi;
      }

      return experiments;
    } catch (e) {
      console.error(e);
      return fallbackApi;
    }
  };
};
